module.exports = __webpack_public_path__ + "img/fuoristrada.076a7ac4.webp";